{
  "Empty": "Pusty"
}
